import { exercises } from '../../data/landingPage';
import PhoneMockup from '../PhoneMockup/PhoneMockup';
import SectionHeading from '../SectionHeading/SectionHeading';
import './ExercisesSection.css';

function ExercisesSection() {
  return (
    <section className="exercises" id="exercises" aria-labelledby="exercises-title">
      <SectionHeading id="exercises-title">
        Different exercises<br />to calm your nervous system
      </SectionHeading>
      <div className="exercise-grid">
        {exercises.map((exercise) => (
          <article className={`exercise-card ${exercise.accent}`} key={exercise.title}>
            <PhoneMockup src={exercise.mockup} alt={`RELI ${exercise.title} exercise screen`} compact />
            <div className="exercise-copy">
              <span>{exercise.icon}</span>
              <div>
                <h3>{exercise.title}</h3>
                <p>{exercise.text}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ExercisesSection;
